export const defer = (timeout: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
